/************************************************************************
** IBM Confidential
**
** IBM Business Analytics: Rapidly Adaptive Visualization Engine
**
** (C) Copyright IBM Corp. 2017
**
** The source code for this program is not published or otherwise divested of its trade secrets, 
** irrespective of what has been deposited with the U.S. Copyright Office.
************************************************************************/
import CodePointIterator from './CodePointIterator';

export default class StringUtils 
{
	/**
	 * This method is used to properly translate String.codePoints()
	 */
    static getCodePoints(str)
    {
        return new CodePointIterator(str);
    }
    
    /**
     * return a String from a unicode codePoint
     * @param {int} codePoint 
     */
    static fromCodePoint(codePoint)
    {
        if(codePoint <= 0xFFFF)
        {
            return String.fromCharCode(codePoint);
        }
        else
        {
            // calculate the low and high surrogate 
            // from CodePointIterator:
            // codePoint = (first - 0xD800) * 0x400 + (second - 0xDC00) + 0x10000;
            codePoint -= 0x10000;
            var first = (codePoint >> 10 /* "/ 0x400"" */ ) + 0xD800;
            var second = (codePoint & 0x3FF) + 0xDC00;

            return String.fromCharCode(first, second);
        }
    	
    }
}


// WEBPACK FOOTER //
// ./src/generated/StringUtils.js